import { render, staticRenderFns } from "./RoltekHeaderLogo.vue?vue&type=template&id=0adbb0c5&scoped=true"
import script from "./RoltekHeaderLogo.vue?vue&type=script&lang=ts"
export * from "./RoltekHeaderLogo.vue?vue&type=script&lang=ts"
import style0 from "./RoltekHeaderLogo.vue?vue&type=style&index=0&id=0adbb0c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adbb0c5",
  null
  
)

export default component.exports